<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="4">
            <v-text-field
              :label="`Perfil da Turma em ${funcionalidade}`"
              v-model="form.filters.nome"
              outlined
              maxlength="25"
              dense
              @keyup.enter="buscarPerfisTurmas"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="form.filters.nivelDeEnsino"
              label="Nível de Ensino"
              :items="form.lists.niveisDeEnsino"
              item-value="id"
              item-text="descricao"
              outlined
              dense
              @keyup.enter="buscarPerfisTurmas"
            ></v-select>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarPerfisTurmas"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarPerfisTurmas()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterPerfilTurma()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        show-expand
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="table.noDataText"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw">
              {{ item.descricao }}
            </p>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarPerfilTurma(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterPerfilTurma(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch': 'mdi-toggle-switch-off'}`"
            :small="true"
            @click="inativarAtivarPerfilTurma(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPerfilTurmaDialog
      :titulo="titulo"
      :niveisDeEnsino="form.lists.niveisDeEnsino"
      :componentesCurriculares="form.lists.componentesCurriculares"
      :funcionalidade="funcionalidade"
      :visible="dialogManterPerfilTurma.visible"
      :content="dialogManterPerfilTurma.content"
      :edit="dialogManterPerfilTurma.edit"
      @onClose="dialogManterPerfilTurma.close()"
      @onSave="buscarPerfisTurmas()"
    ></CadastrarEditarPerfilTurmaDialog>
    <VisualizarPerfilTurmaDialog
      v-if="dialogVisualizarPerfilTurma.visible"
      :titulo="titulo"
      :visible="dialogVisualizarPerfilTurma.visible"
      :content="dialogVisualizarPerfilTurma.content"
      @onClose="dialogVisualizarPerfilTurma.close()"
    ></VisualizarPerfilTurmaDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { PerfilTurma } from '~/commons/classes/perfil-turma';
import PerfilTurmaService from '~/services/perfil-turma.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarPerfilTurmaDialog from "./dialogs/CadastrarEditarPerfilTurmaDialog.vue";
import VisualizarPerfilTurmaDialog from "./dialogs/VisualizarPerfilTurmaDialog.vue";

export default {
  name: "ManterPerfilTurmasView",
  mixins: [PerfilTurmaService, datatablesMixin],
  components: {
    CadastrarEditarPerfilTurmaDialog,
    VisualizarPerfilTurmaDialog,
  },
  data: () => ({
    dialogManterPerfilTurma: Dialog.Build(),
    dialogVisualizarPerfilTurma: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        ativo: null,
        horaInicio: null,
        horaFim: null,
      },
      lists: {
        niveisDeEnsino: [],
        componentesCurriculares: [],
      }
    },
    table: {
      headers: [
        { text: `Perfil da Turma em`, align: 'center', value: 'nome' },
        { text: 'Nível de Ensino', align: 'center', value: 'nivelDeEnsino' },
        { text: 'O que é esperado do aluno', align: 'center', value: 'data-table-expand' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
      noDataText: '',
    },
  }),
  methods: {
    iniciarMensagemDeNenhumRegistroEncontrado() {
      this.table.noDataText = this.$possuiPermissao(`perfilturma.${this.funcionalidade}.listar`)
        ? ''
        : 'Não há registros a serem exibidos';
    },
    buscarNiveisDeEnsino() {
      this.$buscarNivelEnsino().then(({ data }) => {
        this.form.lists.niveisDeEnsino = data.itens;
      });
    },
    buscarComponentesCurriculares() {
      this.$buscarComponenteCurricular().then(({ data }) => {
        this.form.lists.componentesCurriculares = data.itens;
      });
    },
    buscarPerfisTurmas() {
      this.table.noDataText = 'Não há registros a serem exibidos';
      this.$buscarPerfisTurmas(this.funcionalidade, { params: this.form.filters })
        .then(({ data }) => (this.table.itens = data.itens));
    },
    openDialogManterPerfilTurma(perfilturma) {
      perfilturma
        ? this.$visualizarPerfilTurma(this.funcionalidade, perfilturma.id).then(
          ({ data }) => this.dialogManterPerfilTurma.open(new PerfilTurma(data.resposta), true))
        : this.dialogManterPerfilTurma.open(PerfilTurma.Build());
    },
    openDialogVisualizarPerfilTurma(perfilturma) {
      this.$visualizarPerfilTurma(this.funcionalidade, perfilturma.id).then(
        ({ data }) => this.dialogVisualizarPerfilTurma.open(new PerfilTurma(data.resposta)));
    },
    inativarAtivarPerfilTurma(perfilturma) {
      this.$swal({
        text: `Deseja ${perfilturma.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarPerfilTurma(this.funcionalidade, perfilturma.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarPerfisTurmas();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    horaValida(h) {
      if (!h) return true;
      const [hora, minuto] = h.split(':').filter(v => v.length === 2).map(x => parseInt(x));
      const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
      return condicao || 'Hora inválida';
    },
  },
  computed: {
    funcionalidade() {
      return this.$capitalize(this.$route.params.funcionalidade);
    },
    titulo() {
      return `Perfil da Turma em ${this.funcionalidade}`;
    },
  },
  watch: {
    '$route.params.funcionalidade': {
      handler() {
        this.iniciarMensagemDeNenhumRegistroEncontrado();
        document.title = this.titulo;
        this.table.headers[0].text = this.titulo;
        this.form.filters.nome = null;
        this.form.filters.ativo = null;
        this.form.filters.horaInicio = null;
        this.form.filters.horaFim = null;
        this.table.itens = [];
      },
      immediate: true,
    },
  },
  mounted() {
    this.iniciarMensagemDeNenhumRegistroEncontrado();
    this.buscarComponentesCurriculares();
    this.buscarNiveisDeEnsino();
  }
};
</script>
